import { useSearchParams } from "react-router-dom";
import { useFetch } from "@/Hooks/useFetch";
import type { BaseResponse } from "@models/base";
import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { setWithExpiry } from "@/utils/token";
import { ModelLoginUserResponse } from "@models/all";
export const BASE_URL = import.meta.env.VITE_API_URL;

const LoginNaver = () => {
  const [searchParams] = useSearchParams();
  const ncode = searchParams.get("ncode");

  const tokenHook = useFetch<BaseResponse<ModelLoginUserResponse>>({
    url: `${BASE_URL}/user/login/naver?ncode=${ncode}`,
    method: "GET",
  });

  useEffect(() => {
    if (tokenHook.fetchData?.data) {
      setWithExpiry("token", tokenHook.fetchData.data.token);
      setWithExpiry("userInfo", tokenHook.fetchData.data);
      window.location.href = "/";
    }
  }, [tokenHook.fetchData]);

  return (
    <div className="h-[600px] flex flex-col items-center justify-center">
      <div className="bg-white p-8 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] w-full max-w-md text-center">
        {tokenHook.error ? (
          <div className="text-red-600 bg-red-50 p-4 rounded-lg border border-red-200">
            <p className="font-medium">로그인 중 오류가 발생했습니다</p>
            <p className="text-sm mt-1">{tokenHook?.error?.message}</p>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <Loader2 className="w-12 h-12 text-[#03C75A] animate-spin" />
            <h2 className="text-xl font-semibold text-gray-700">
              네이버 계정으로 로그인 중
            </h2>
            <p className="text-gray-500">잠시만 기다려주세요...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginNaver;
